import HeaderLogo from './HeaderLogo';
import HeaderNav from './HeaderNav';
import LanguageSelector from './LanguageSelector';
import UserMenu from './UserMenu';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white px-6 py-4 shadow-sm">
      <div className="flex items-center justify-between max-w-[1440px] mx-auto">
        {/* Left */}
        <div className="flex items-center gap-8">
          <HeaderLogo />
          <HeaderNav />
        </div>

        {/* Right */}
        <div className="flex items-center gap-3">
          <LanguageSelector />
          <UserMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
